// @ts-nocheck
import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  FlaskConical,
  ShoppingCart,
  Users,
  BarChart3,
  FileText,
  DollarSign,
  Settings,
  HelpCircle,
  Droplets,
  X,
} from 'lucide-react';

const navItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard', exact: true },
  { path: '/inventory', icon: Package, label: 'Inventory' },
  { path: '/production', icon: FlaskConical, label: 'Production' },
  { path: '/sales', icon: ShoppingCart, label: 'Sales & Distribution' },
  { path: '/team', icon: Users, label: 'Team' },
];

const futureItems = [
  { path: '/reporting', icon: BarChart3, label: 'Reporting', disabled: false },
  { path: '/compliance', icon: FileText, label: 'Compliance', disabled: false },
  { path: '/accounting', icon: DollarSign, label: 'Accounting', disabled: false },
  { path: '/settings', icon: Settings, label: 'Settings', disabled: false },
];

const Sidebar = ({ isOpen, isMobile, onClose }) => {
  return (
    <aside
      className={`fixed top-0 left-0 h-screen bg-[#0f172a] text-white flex flex-col z-50 transition-transform duration-300 w-[240px] ${
        isMobile ? (isOpen ? 'translate-x-0' : '-translate-x-full') : 'translate-x-0'
      }`}
    >
      {/* Logo & Close Button */}
      <div className="flex items-center justify-between h-16 px-4 border-b border-white/8">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-[#0891B2] flex items-center justify-center flex-shrink-0">
            <Droplets size={18} className="text-white" />
          </div>
          <div className="flex flex-col">
            <span className="text-[19px] font-bold tracking-tight leading-none">
              Pourix
            </span>
          </div>
        </div>
        {isMobile && (
          <button
            onClick={onClose}
            className="lg:hidden p-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            <X size={20} />
          </button>
        )}
      </div>

      {/* Main nav */}
      <nav className="flex-1 py-4 px-2 overflow-y-auto">
        <div className="space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              onClick={isMobile ? onClose : undefined}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-[#0891B2] text-white'
                    : 'text-white/70 hover:bg-white/8 hover:text-white'
                }`
              }
            >
              <item.icon size={20} className="flex-shrink-0" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>

        {/* Additional modules */}
        <div className="mt-8">
          <div className="space-y-1">
            {futureItems.map((item, idx) => (
              <NavLink
                key={idx}
                to={item.path}
                onClick={isMobile ? onClose : undefined}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-[#0891B2] text-white'
                      : 'text-white/70 hover:bg-white/8 hover:text-white'
                  }`
                }
              >
                <item.icon size={20} className="flex-shrink-0" />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        </div>
      </nav>

      {/* Bottom */}
      <div className="p-2 border-t border-white/8">
        <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/70 hover:bg-white/8 hover:text-white transition-colors">
          <HelpCircle size={20} className="flex-shrink-0" />
          <span>Help & Support</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
